export class Filter {
    [key: string]: boolean | number | string;
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/model/filter.model.ts